export const UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST = "UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST";
export const UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS = "UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS";
export const UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE = "UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE";
export const UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_RESET = "UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_RESET";
export const updateWhatsappNdrVerificationChargesRequest = (payload) => ({
    type: UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST,
    payload,
});
export const updateWhatsappNdrVerificationChargesSuccess = (payload) => ({
    type: UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS,
    payload,
});
export const updateWhatsappNdrVerificationChargesFailure = (payload) => ({
    type: UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE,
    payload,
});
export const updateWhatsappNdrVerificationChargesReset = () => ({
    type: UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_RESET,
});
